'use strict';


export class Grid {
	constructor (context,width,height,cellSize,color,lineWidth) {
		this.context = context;
		this.width = width;
		this.height = height;
		this.cellSize = cellSize;
		this.color = color;
		this.lineWidth = lineWidth;
		this.gridCanvas = document.createElement('canvas');
		this.gridCanvas.style.position = 'absolute';
		this.gridCanvas.style.left = 0;
		this.gridCanvas.style.top = 0;
		this.gridCanvas.style.zIndex = -1;
		this.gridCanvas.width = this.width;
		this.gridCanvas.height = this.height;
		this.gridContext = this.gridCanvas.getContext('2d');
		this.cells = [];
	}
	
	draw() {
		this.clear();
		this.cells = [];
		this.gridContext.save();
		this.gridContext.beginPath();
		this.gridContext.lineWidth = this.lineWidth;
		this.gridContext.strokeStyle = this.color;
		
		for (let x = 0; x < this.width; x += this.cellSize) {
			for (let y = 0; y < this.height; y += this.cellSize) {
				this.gridContext.strokeRect(x, y, this.cellSize, this.cellSize);
				this.cells.push(new GridCell(this.context,x,y,this.cellSize));
			}
		}
		this.gridContext.closePath();
		this.gridContext.restore();
	}
	
	clear() {
		this.gridContext.clearRect(0,0,this.width,this.height);
	}
	
	getCell(x,y) {
		return this.cells.find(cell => cell.contains(x,y));
	}
}


class GridCell {
	constructor (context,x,y,size) {
		this.context = context;
		this.x = x;
		this.y = y;
		this.size = size;
		this.width = this.x + size;
		this.height = this.y + size;
	}
	
	contains(x,y) {
		return x >= this.x && x <= this.width &&
			y >= this.y && y <= this.height;
	}
	
	getClosestPoint(x,y,minDist) {
		const distances = this.distance(x,y);
		const minDistance = Math.min(...distances);
		
		if (minDistance > minDist) {
			return null;
		}
		
		const index = distances.indexOf(minDistance);
		let coordX = null;
		let coordY = null;
		
		switch (index) {
			case 0:
				coordX = this.x;
				coordY = this.y;
				break;
			case 1:
				coordX = this.width;
				coordY = this.y;
				break;
			case 2:
				coordX = this.width;
				coordY = this.height;
				break;
			case 3:
				coordX = this.x;
				coordY = this.height;
				break
		}
		
		return {x: coordX, y: coordY};
	}
	
	distance(x,y) {
		// const dx = this.x - x, dy = this.y - y;
		// return Math.sqrt(dx * dx + dy * dy);
		return  [
			Math.sqrt((this.x - x) * (this.x - x) + (this.y - y) * (this.y - y)),
			Math.sqrt((this.width - x) * (this.width - x) + (this.y - y) * (this.y - y)),
			Math.sqrt((this.width - x) * (this.width - x) + (this.height - y) * (this.height - y)),
			Math.sqrt((this.x - x) * (this.x - x) + (this.height - y) * (this.height - y))
		]
	}
	
	draw(color) {
		this.context.fillStyle = color;
		this.context.fillRect(this.x - 1, this.y - 1, this.size + 1, this.size + 1);
	}
	
}
